<script setup lang="ts"></script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1812_11749)">
      <path
        d="M12.0211 11.0778L14.8764 13.9325L13.9331 14.8758L11.0784 12.0205C10.0162 12.872 8.69507 13.3351 7.33374 13.3332C4.02174 13.3332 1.33374 10.6452 1.33374 7.33318C1.33374 4.02118 4.02174 1.33318 7.33374 1.33318C10.6457 1.33318 13.3337 4.02118 13.3337 7.33318C13.3357 8.69451 12.8726 10.0157 12.0211 11.0778ZM10.6837 10.5832C11.5298 9.7131 12.0023 8.5468 12.0004 7.33318C12.0004 4.75451 9.91174 2.66651 7.33374 2.66651C4.75507 2.66651 2.66707 4.75451 2.66707 7.33318C2.66707 9.91118 4.75507 11.9998 7.33374 11.9998C8.54736 12.0018 9.71366 11.5293 10.5837 10.6832L10.6837 10.5832Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1812_11749">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
